import {
  CommonSharedByType,
  mapCommonSharedByType,
} from "../../Share/CommonSharedByType";
import { mapShareContactTypes, ShareContactTypes } from "../ShareContactTypes";

export interface AttendanceProjectType {
  project_id?: number;
  job_number?: string;
  project_type?: string;
  description?: string;
  address?: string;
  full_address?: string;
  post_code?: string;
  is_own_project?: boolean;
  contact?: ShareContactTypes[];
  share_list?: ShareContactTypes[];
  shared_by?: CommonSharedByType | null;
  can_edit?: boolean;
}

// to single object maping
export const mapAttendanceProjectType = (data: any): AttendanceProjectType => {
  if (!data) {
    throw new Error("Invalid Data");
  }
  const res: AttendanceProjectType = {
    project_id: data.project_id,
    job_number: data.job_number,
    project_type: data.project_type,
    description: data.description,
    address: data.address,
    post_code: data.post_code,
    full_address: data.full_address,
    is_own_project: data.is_own_project||true,
    contact:data.contact ? mapShareContactTypes(data.contact):[],
    share_list: data.share_list ? mapShareContactTypes(data.share_list) : [],
    shared_by: data.shared_by ? mapCommonSharedByType(data.shared_by) : null,
    can_edit: data.can_edit||false,
  };
  return res;
};

// maping list objects
export const mapAttendanceProjectTypes = (
  data: any[]
): AttendanceProjectType[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }
  return data.map(mapAttendanceProjectType);
};
